<template>
  <v-card class="mx-auto" light :loading="loading">
    <v-card-title>
      Usuarios
      <div class="flex-grow-1"></div>
       <v-card-actions>
        <v-btn small color="blue-grey" dark @click="agregar = true">Agregar</v-btn>
      </v-card-actions>
    </v-card-title>
    <div style=" display: flex; align-items: center; justify-content: end;"> 
      <v-col cols="6" >
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Buscar"
          single-line
          hide-details
          clearable
          @change="buscarUsuarios()"
        ></v-text-field>
      </v-col>
    </div>

    <v-card-text>
      <tabla-datos-usuarios
        :headers="headers"
        :usuarios="usuarios"
        :search="search"
        locale="es-mx"
        hide-default-footer
        @modificarDatos="modificarDatos"
        @resetearPass="resetearPass"
      />

    <paginacion
      :page="page"
      :pages="pages"
      :totalDatos="totalUsuarios"
      :perPage="perPage"
      :cantPage="cantPage"
      @paginaAnt="paginaAnt"
      @paginaSig="paginaSig"
      @cambiarPag="cambiarPag"
    />
    </v-card-text>
    <div style="padding:20px">
      <logs :logs="logs"></logs>
    </div>


    <agregar-usuario
      v-if="agregar"
      :mostrar="agregar"
      @cancelar="agregar = false"
      @usuarioAgregado="usuarioAgregado"
    />
    <modificar-usuario
      v-if="modificar.mostrar"
      :mostrar="modificar.mostrar"
      :id="modificar.id"
      @cancelar="modificar.mostrar = false"
      @usuarioModificado="usuarioModificado"
    />
    <reset-password
      v-if="resetPass.mostrar"
      :mostrar="resetPass.mostrar"
      :id="resetPass.id"
      :nombre="resetPass.nombre"
      @cancelar="resetPass.mostrar = false"
    />
  </v-card>
</template>

<script>
import AgregarUsuario from "./agregarUsuario";
import ModificarUsuario from "./modificarUsuario";
import ResetPassword from "./resetPassword";
import tablaDatosUsuarios from "./tablaDatosUsuarios.vue";
import { cargarUsuariosPaginadosService } from "./usuarios.service";
import Paginacion from "../MainTemplate/paginacion/paginacion.vue";
import logs from "../logs/logs.vue"
import { mapGetters} from 'vuex'

export default {
  computed: {
      ...mapGetters(['role'])
  },
  components: {
    AgregarUsuario,
    ModificarUsuario,
    ResetPassword,
    tablaDatosUsuarios,
    Paginacion,
    logs
  },
  data: () => ({
    loading: false,
    search: "",
    agregar: false,
    modificar: {
      mostrar: false,
      id: null,
    },
    resetPass: {
      mostrar: false,
      id: null,
      nombre: null,
    },
    headers: [
      { text: "", value: "options", sortable: false },
      { text: "Código", value: "codigo" },
      { text: "Usuario", value: "nombreCompleto" },
      { text: "Status", value: "status" },
      { text: "Rol", value: "role" },
      { text: "Correo", value: "correo" },
      { text: "Puesto", value: "puesto" },
      { text: "Dependencia", value: "dependencia" },
    ],
    usuarios: [],
    page: 1,
    pages: 1,
    totalUsuarios: 1,
    perPage: 1,
    cantPage: 1,
    auxPage: 1,
    logs:[]
  }),
  created() {
    if(this.role!='super-admin'){
      this.$router.push('/oficios');
    }
    else this.cargarUsuarios();
  },
  methods: {
    async cargarUsuarios() {
      try {
        this.loading = true;
        if (!this.search || this.search.trim() === "") {
          const serverResponse = await cargarUsuariosPaginadosService(
            this.page,
            0
          );
          this.loading = false;
          this.usuarios = serverResponse.usuarios;
          this.pages = serverResponse.pages;
          this.totalUsuarios = serverResponse.totalUsuarios;
          this.logs=serverResponse.logs;
          this.contadorPaginas();
        } else {
          const serverResponse = await cargarUsuariosPaginadosService(
            this.page,
            this.search.trim()
          );
          this.loading = false;
          this.usuarios = serverResponse.usuarios;
          this.pages = serverResponse.pages;
          this.totalUsuarios = serverResponse.totalUsuarios;
          this.contadorPaginas();
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
    modificarDatos(id) {
      this.modificar.id = id;
      this.modificar.mostrar = true;
    },
    resetearPass(id) {
      let usuario = this.usuarios.find((x) => x._id == id);
      this.resetPass.id = usuario._id;
      this.resetPass.nombre = usuario.nombreCompleto;
      this.resetPass.mostrar = true;
    },
    usuarioAgregado({usuario, log}) {
      this.usuarios.push(usuario);
      this.agregar = false;
      this.logs.unshift(log)
    },
    usuarioModificado({usuario, log}) {
      let index = this.usuarios.findIndex((x) => x._id == usuario._id);
      this.usuarios.splice(index, 1, usuario);
      this.modificar.id = null;
      this.modificar.mostrar = false;
      this.logs.unshift(log)

    },
    contadorPaginas() {
      this.perPage = this.page * 10;
      if (this.totalUsuarios < this.perPage) {
        this.cantPage = this.perPage - 9; // cantPage = 10 - 9 = 1
        this.perPage = this.totalUsuarios; // perPage = 9
        this.auxPage = this.perPage - this.cantPage; // auxPage = 9 - 1 = 8
        this.cantPage = this.perPage - this.auxPage; // cantPage = 9 - 8
      } else {
        this.cantPage = this.perPage - 9;
      }
    },
    paginaSig() {
      this.page++;
      this.cargarUsuarios();
    },
    paginaAnt() {
      this.page--;
      this.cargarUsuarios();
    },
    cambiarPag(pagina) {
      this.page = pagina;
      this.cargarUsuarios();
    },
    buscarUsuarios() {
      this.page = 1;
      this.cargarUsuarios();
    },
  },
};

</script>







